export function useMinWithdrawAmount() {
  // TODO: Fetch this amount from SDK.
  return 1000000n // 0.01 BTC
}
